module.exports = __webpack_public_path__ + "static/img/syBd.6b21097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/syBd.png
// module id = W5BX
// module chunks = 0